/* eslint-disable no-shadow */
/* eslint-disable semi */

import { CookieConsentService } from '@/services/storage.service';

const state = {
  cookieConsentAccepted: CookieConsentService.getCookieConsentAccepted(),
  cookieConsentProcessed: CookieConsentService.getCookieConsentProcessed(),
}

const getters = {
  cookieConsentProcessed(state) {
    return !!state.cookieConsentProcessed;
  },
}

const mutations = {
  SET_COOKIE_CONSENT_LAYER_ACCEPTED() {
    CookieConsentService.saveCookieConsentAccepted(true);
  },
  SET_COOKIE_CONSENT_LAYER_DECLINED() {
    CookieConsentService.saveCookieConsentAccepted(false);
  },
  SET_COOKIE_CONSENT_PROCESSED(state) {
    CookieConsentService.saveCookieConsentProcessed(true);
    state.cookieConsentProcessed = true;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
